import { initSentry } from "./lib/sentry";
initSentry();

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "@/lib/analytics";

// Keep Replit's development helper out of production HTML and its strict CSP.
if (import.meta.env.DEV) {
  const banner = document.createElement("script");
  banner.src = "https://replit.com/public/js/replit-dev-banner.js";
  banner.async = true;
  document.head.appendChild(banner);
}

initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
